import { cn } from '@/app/utils/cn';
import { DotBlockEditor } from '@/components/shared/decodeTextBlock';
import customRenderers from '@/components/block-editor';
import safeJsonParse from '@/app/utils/safeJSONParse';

const accentColorClasses = {
    fuschia: 'border-fuschia-500',
    blue: 'border-blue-500',
    indigo: 'border-indigo-500',
    orange: 'border-orange-500',
    green: 'border-green-500',
    cyan: 'border-cyan-500'
};

function resolveAttribution(author) {
    // author is a relation field. When the GQL query selects author { firstName ... },
    // dotCMS returns a resolved Contributor contentlet (or an array of them).
    const related = Array.isArray(author) ? author[0] : author;
    if (!related || typeof related !== 'object') return { name: '', title: '' };

    const name = [related.firstName, related.lastName].filter(Boolean).join(' ');
    const title = [related.title, related.company].filter(Boolean).join(', ');
    return { name, title };
}

function QuoteCard({ heading, body, body_raw, quote, author, accentColor = 'fuschia' }) {
    const parsedBody = body ?? safeJsonParse(body_raw);
    const borderClass = accentColorClasses[accentColor] ?? accentColorClasses.fuschia;
    const { name, title } = resolveAttribution(author);

    return (
        <section
            data-component="quote-card"
            className="row-default-p container grid grid-cols-1 items-center gap-6 lg:grid-cols-2 lg:gap-8">
            {heading && (
                <h2 className="text-3xl font-bold leading-tight text-gray-900 sm:text-4xl lg:text-5xl">
                    {heading}
                </h2>
            )}

            <div className="rounded-2xl bg-white p-8 shadow-[0_20px_50px_-24px_rgba(12,18,49,0.18)] sm:p-10">
                {parsedBody && (
                    <div className="sm:text-lg text-base leading-relaxed text-gray-700">
                        <DotBlockEditor customRenderers={customRenderers} blocks={parsedBody} />
                    </div>
                )}

                {quote && (
                    <blockquote
                        className={cn(
                            'mt-8 border-l-4 pl-6 text-2xl font-medium italic leading-snug text-gray-900 sm:text-3xl',
                            borderClass
                        )}>
                        &ldquo;{quote}&rdquo;
                    </blockquote>
                )}

                {(name || title) && (
                    <p className="mt-6 text-sm text-gray-500">
                        {'— '}
                        {name}
                        {name && title && ', '}
                        {title}
                    </p>
                )}
            </div>
        </section>
    );
}

export default QuoteCard;
